import React, { useEffect, useState } from 'react'
import styles from './Index.module.css';
import Userlist from './Userlist';
import UserInformation from './UserInformation';
import { Redirect, Route, Switch } from "react-router";
import SettingDashboard from './SettingDashboard';
import WarningMessage from '../../common/warnMsg';
import { useHistory } from "react-router-dom"
import httpService from '../../../services/http.service';
import ErrorMessage from '../../common/errorMsg';
import LicenseError from './LicenseError';

const PropertyManagerLayout = () => {
  const [isPropertyOpen, setIsPropertyOpen] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [refresh, setRefresh] = useState(0)
  const [isValidLicence, setIsValidLicence] = useState(true)
  const history = useHistory()

  const [allData, setAllData] = useState([])

  const checkVaildLicence = async () => {
    try {

      const { data } = await httpService.get("property-manager/license")

      if (data.ack === "0") {
        setIsValidLicence(false)
        return history.push("/property-manager-dashboard/settings/subscription")
      }

      fetchData()
    } catch (error) {
      if (error) {
        WarningMessage(error.response.data.message)
      }

      if (error.response.status === 401) {
        history.push("/")
        ErrorMessage(error.response.data.message)
        localStorage.clear()
      }
    }
  }

  const fetchData = async () => {
    try {
      const { data } = await httpService.get("property-manager/allData")

      if (data.ack === "1") {
        setAllData(data.userData)
      }


    } catch (error) {
      if (error) {
        WarningMessage(error.response.data.message)
      }

      if (error.response.status === 401) {
        history.push("/")
        ErrorMessage(error.response.data.message)
        localStorage.clear()
      }
    } finally {
      setIsLoading(false)
    }
  }


  useEffect(() => {
    checkVaildLicence()
  }, [refresh])
  return (
    <div className={styles.container}>
      {isValidLicence && <Userlist allData={allData} isLoading={isLoading} isPropertyOpen={isPropertyOpen} setIsPropertyOpen={setIsPropertyOpen} />}
      <>
        <Switch>

          <Route path="/property-manager-dashboard/settings"
            render={() => {
              return <SettingDashboard isValidLicence={isValidLicence} setRefresh={setRefresh} />
            }}
          />
          <Route path="/property-manager-dashboard"
            render={() => {
              return (isValidLicence ? <UserInformation allData={allData} isLoading={isLoading} isPropertyOpen={isPropertyOpen} setIsPropertyOpen={setIsPropertyOpen} setRefresh={setRefresh} /> : <LicenseError />)
            }}
          />
          {/* <Redirect from="/" to={"/property-manager-dashboard"} /> */}
        </Switch>
      </>
    </div>
  )
}

export default PropertyManagerLayout